---
en:
  data_export:
    budget_revenue: Budget revenue
    budget_volume: Budget volume
    downtime_comment: Downtime comments
    downtime_cost: Downtime cost
    downtime_reason: Downtime reasons
    downtime_volume: Downtime volume
    from_date: From date
    heading: Export hourly values to a spreadsheet
    individual_power_plants: Select individual power plants
    missing_exchange_rate_error: Exchange rate data is missing for the selected period and currency. Please contact support.
    pending_email: The spreadsheet will be sent by email when it's ready.
    power_plants: Power plants
    price_areas: Select all plants in price area
    prices: Prices
    rate_limited: Too many requests
    ready_notification:
      body: Click view to download the spreadsheet.
      title: Your data export is ready
    report:
      budget_revenue:
        report_sheet_header: Revenue
        report_sheet_name: Budget revenue
        summary_sheet_header: Budget revenue %{currency}
      budget_volume:
        report_sheet_header: MWh
        report_sheet_name: Budget volume
        summary_sheet_header: Budget volume MWh
      downtime_comment:
        report_sheet_header: Comments
        report_sheet_name: Downtime comments
      downtime_cost:
        report_sheet_header: Cost
        report_sheet_name: Downtime cost
        summary_sheet_header: Total downtime cost %{currency}
      downtime_reason:
        report_sheet_header: Reason
        report_sheet_name: Downtime reason
      downtime_volume:
        report_sheet_header: MWh
        report_sheet_name: Downtime volume
        summary_sheet_header: Total downtime volume MWh
      monthly_sheet_left_header: Power plant
      monthly_sheet_sum_header: Total
      monthly_sheet_title: Monthly summary
      monthly_sheet_top_header: Period
      prices:
        report_sheet_header: Prices
        report_sheet_name: Prices
        summary_sheet_header: Prices (%{currency})
      report_sheet_left_headers:
      - Timezone
      - Hour
      revenue:
        report_sheet_header: Revenue
        report_sheet_name: Revenue
        summary_sheet_header: Gross revenue %{currency}
      summary_sheet_left_header: Data export
      summary_sheet_title: Summary
      summary_sheet_top_header: Period
      volume:
        report_sheet_header: MWh
        report_sheet_name: Volume
        summary_sheet_header: Production volume MWh
    report_types: Report types
    revenue: Revenue
    select_power_plants: Select power plants
    to_date: To date
    volume: Volume
  errors:
    messages:
      export_too_large: The export is too large. Please try a smaller data set.
      no_power_plants_selected: No power plants selected
